<template>
  <a-card title="设备管理">
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item>
          <a-input placeholder="用户 ID" v-model:value="formSearch.user_id" />
        </a-form-item>
          <a-form-item>
          <a-input placeholder="Device ID" v-model:value="formSearch.device_id" />
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
        </a-form-item>
      </a-form>
    </a-space>

    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
      <a-table 
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
        <template #nickname="{ record }">
          <span>{{ record.nickname ? record.nickname : '-' }}</span>
        </template>
        <template #is_vip="{ record }">
          <a-tag v-if="record.is_vip" color="red">VIP</a-tag>
        </template>
        <template #action="{ record }">
          <a-space>
            <!-- <a-button v-if="record.is_delete == 0"   warn @click="handleUpdate(record)"  >编辑</a-button> -->
            <a-popconfirm
              title="失效多余的设备之后，被设备数限制的用户可以再次登录，确定失效吗?"
              ok-text="确定"
              cancel-text="不了"
              @confirm="handleDelete(record)"
            >
              <a-button  danger   >失效</a-button>
            </a-popconfirm>
             <a-popconfirm
              title="删除后，对应设备的非会员任务次数将被清除，确定删除吗?"
              ok-text="确定"
              cancel-text="不了"
              @confirm="handleRemove(record)"
            >
              <a-button  danger   >删除</a-button>
            </a-popconfirm>
              <a-popconfirm
              title="删除后，当前用户的关联设备被清除，方便测试新人策略。删除后需要重启 APP 来注册设备，确定删除吗?"
              ok-text="确定"
              cancel-text="不了"
              @confirm="handleClear(record)"
            >
              <a-button  danger   >删除关联设备</a-button>
            </a-popconfirm>
          </a-space>
          </template>
    
      </a-table>
  </a-card>
  

</template>
<script>
import { defineComponent,  onMounted} from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import axios from 'axios'
import { message } from 'ant-design-vue';
import request from '@/utils/request'
import { Modal } from 'ant-design-vue';
import { useStore } from 'vuex'


export default defineComponent({
  components: {
    // UserEditor,
    SearchOutlined
  },
  data(){
    return {
      loading: false,
      openDia: false,
      dataSource: [],
      formAdd: {
        phone: '',
        country_code: "+86",
        user_id: '',
        product_id: '1'
      },
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',

       formSearch: {
        user_id: '',
        device_id: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    // this.handleTableChange()
  },
  computed:{
    nickname : () => {
      const store = useStore()
      if (store) {
        return store.state.user.nickname
      }
      
    },
  },
  methods: {
    async handleDelete(record){
      const rsp = await request.put(`/api/devices/delete`, {
        "user_id": `${record.user_id}`,
        "device_id": record.device_id
      })
      this.handleTableChange( this.pagination)
    },
    async handleClear(record){
      const rsp = await request.post(`/api/devices/clear`, {
        "user_id": `${record.user_id}`,
        "device_id": record.device_id
      })
      this.handleTableChange(this.pagination)
    },
    async handleRemove(record){
      const rsp = await request.post(`/api/devices/remove`, {
        "user_id": `${record.user_id}`,
        "device_id": record.device_id
      })
      this.handleTableChange( this.pagination)
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      const rsp = await request.get('/api/devices/search', {
        offset: (pagi.current - 1) * pagi.pageSize ,
        limit: pagi.pageSize,
        user_id: this.formSearch.user_id,
        device_id: this.formSearch.device_id
      })
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
      {
          title: 'UID',
          dataIndex: 'user_id',
          key: 'user_id',
        },
        {
          title: '用户昵称',
          dataIndex: 'nickname',
          key: 'nickname',
          slots: { customRender: 'nickname' },
        },
        {
          title: 'VIP',
          dataIndex: 'is_vip',
          key: 'is_vip',
          slots: { customRender: 'is_vip' },
        },
        {
          title: '设备 ID',
          dataIndex: 'device_id',
          key: 'device_id',
          // slots: { customRender: 'is_vip' },
        },
        {
          title: 'APP 版本',
          dataIndex: 'version',
          key: 'version',
          // slots: { customRender: 'is_vip' },
        },
        {
          title: '失效',
          dataIndex: 'is_del',
          key: 'is_del',
          // slots: { customRender: 'is_vip' },
        },
        
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
        },
        {
          title: '修改时间',
          dataIndex: 'updated_at',
          key: 'updated_at',
        },{
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
        
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>